import { OnboardingAction, OnboardingInterface } from '@agilox/common';

export const analyticsOnboarding: Array<OnboardingInterface> = [
	{
		headline: 'onboarding.slide1.headline',
		text: 'onboarding.slide1.text',
		buttonText: 'general.next',
		buttonAction: OnboardingAction.NEXT,
		linkText: 'general.skip',
		linkAction: OnboardingAction.SKIP,
	},
	{
		image: {
			en: 'assets/images/onboarding/en/chapter_2.webp',
			de: 'assets/images/onboarding/de/kapitel_2.webp',
			maxHeight: '335px',
		},
		headline: 'onboarding.slide2.headline',
		text: 'onboarding.slide2.text',
		buttonText: 'general.next',
		buttonAction: OnboardingAction.NEXT,
		linkText: 'general.back',
		linkAction: OnboardingAction.BACK,
	},
	{
		image: {
			en: 'assets/images/onboarding/en/chapter_3.webp',
			de: 'assets/images/onboarding/de/kapitel_3.webp',
		},
		headline: 'onboarding.slide3.headline',
		text: 'onboarding.slide3.text',
		buttonText: 'general.next',
		buttonAction: OnboardingAction.NEXT,
		linkText: 'general.back',
		linkAction: OnboardingAction.BACK,
	},
	{
		image: {
			en: 'assets/images/onboarding/en/chapter_4.webp',
			de: 'assets/images/onboarding/de/kapitel_4.webp',
		},
		headline: 'onboarding.slide4.headline',
		text: 'onboarding.slide4.text',
		buttonText: 'general.next',
		buttonAction: OnboardingAction.NEXT,
		linkText: 'general.back',
		linkAction: OnboardingAction.BACK,
	},
	{
		image: {
			en: 'assets/images/onboarding/en/chapter_5.webp',
			de: 'assets/images/onboarding/de/kapitel_5.webp',
		},
		headline: 'onboarding.slide5.headline',
		text: 'onboarding.slide5.text',
		buttonText: 'general.next',
		buttonAction: OnboardingAction.NEXT,
		linkText: 'general.back',
		linkAction: OnboardingAction.BACK,
	},
	{
		image: {
			en: 'assets/images/onboarding/en/chapter_6.webp',
			de: 'assets/images/onboarding/de/kapitel_6.webp',
			maxHeight: '40px',
		},
		headline: 'onboarding.slide6.headline',
		text: 'onboarding.slide6.text',
		buttonText: 'general.next',
		buttonAction: OnboardingAction.NEXT,
		linkText: 'general.back',
		linkAction: OnboardingAction.BACK,
	},
	{
		image: {
			en: 'assets/images/onboarding/en/chapter_7.webp',
			de: 'assets/images/onboarding/de/kapitel_7.webp',
		},
		headline: 'onboarding.slide7.headline',
		text: 'onboarding.slide7.text',
		buttonText: 'general.done',
		buttonAction: OnboardingAction.DONE,
		linkText: 'general.back',
		linkAction: OnboardingAction.BACK,
	},
];
